import { TemplateCodeParameter } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a TemplateCodeParameter.
 *
 * @param obj - The value to check.
 * @returns True if the value is a TemplateCodeParameter.
 */
export const isTemplateCodeParameter = (obj: unknown): obj is TemplateCodeParameter => {
  if (!isObjectRecord(obj)) return false;
  if (!isNamedObject(obj)) return false;
  const templateCodeParameter = obj as TemplateCodeParameter;

  if (
    templateCodeParameter.valueSource !== undefined &&
    typeof templateCodeParameter.valueSource !== "string"
  )
    return false;

  if (templateCodeParameter.value !== undefined) {
    if (!Array.isArray(templateCodeParameter.value)) return false;
    if (templateCodeParameter.value.some((value) => typeof value !== "string")) return false;
  }

  return true;
};
